<script lang="ts">
  import Icon from "../../../../../shared/javascripts/svelte/Components/Icon.svelte";

  export let onClickGetStarted: any;
</script>

<style>
  .container {
    max-width: 1100px;
    background-color: white;
  }
</style>

<nav class="fizz-subnav fizz-stack-48">
  <div class="fizz-space-between">
    <div class="fizz-flex-row">
      <h1 class="default-subheader--bold">Storefronts</h1>
    </div>
  </div>
</nav>

<div class="fizz-flex-row container fizz-justify-center fizz-margin-auto fizz-inset-squish-64">
  <div>
    <h1 class="fizz-heading-1 fizz-stack-16">Customize your catalog</h1>
    <p class="fizz-stack-24"
      >Personalize your catalog on Provi to increase online sales and support sales efforts with
      your own Storefront.</p
    >
    <div class="fizz-flex-row">
      <button class="fizz-button-secondary cursor-pointer" on:click={onClickGetStarted}
        >Get Started</button
      >
      <a
        href="https://support.provi.com/s/topic/0TODn000000YINAOA4/storefronts"
        class="fizz-button-text"
      >
        Learn More
      </a>
    </div>
  </div>

  <Icon width="250" height="250" type="NewProducts"></Icon>
</div>
